import { twMerge } from 'tailwind-merge';

type FeedbackStatusDotProps = {
  className?: string;
};

const FeedbackStatusDot: React.FC<FeedbackStatusDotProps> = ({ className }) => {
  return (
    <div
      className={twMerge(
        'flex w-[6px] h-[6px] rounded-[50%] bg-primary-300 items-center',
        className,
      )}
    />
  );
};

export default FeedbackStatusDot;
